import { AutogenModelContact, AutogenRowContact } from "./autogen/AutogenModelContact";

export class ModelContact extends AutogenModelContact<RowContact> {
    constructor() {
        super(RowContact);
    }
}

export class RowContact extends AutogenRowContact {
}